import selectModel from "./model"

export default function selectObserver(state, engine, model) {
  const modelState = selectModel(state, engine, model)
  return modelState ? modelState.observer : false
}
